import { render } from "./MediaflowTypePicker.vue?vue&type=template&id=5f10affd"
import script from "./MediaflowTypePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowTypePicker.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowTypePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f10affd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f10affd', __exports__)) {
    api.reload('5f10affd', __exports__)
  }
  
  module.hot.accept("./MediaflowTypePicker.vue?vue&type=template&id=5f10affd", () => {
    api.rerender('5f10affd', render)
  })

}


export default __exports__